export enum PostedFlightStatusType {
  NotLogged = 1,
  Logged = 2,
  Verified = 3,
  Hidden = 4
}
